import InputMask from '@mona-health/react-input-mask';
import styled from 'styled-components';

interface ContainerProps {
	$inputSize?: string;
}

const Container = styled.div<ContainerProps>`
	width: ${props =>
		props.$inputSize === '2/4'
			? '66%'
			: props.$inputSize === '3/4'
				? '33%'
				: props.$inputSize === '1/2'
					? '50%'
					: props.$inputSize === 'full'
						? '100%'
						: '100%'};
	color: #575757;
	font-weight: bold;
`;

export const InputTextMask = ({
	$error,
	label,
	name,
	onChange,
	type,
	inputmode,
	$inputSize,
	placeholder,
	value,
	pattern,
	maxLength
}: InputProps & ContainerProps): JSX.Element => {
	const onChangeInputMask = (e: any) => {
		e.preventDefault();
		const value = e.target.value;
		const phoneNo = value.replace(/[^\d]/g, '');
		onChange && onChange(phoneNo);
	};

	return (
		<Container $inputSize={$inputSize}>
			{label && <Label>{label}</Label>}
			<InputMask
				mask="(999) 999-9999"
				value={value}
				onChange={onChangeInputMask}
				style={{ letterSpacing: '0.5px' }}
			>
				<StyledInput
					label={label}
					name={name}
					type={type}
					inputmode={inputmode}
					placeholder={placeholder}
					value={value}
					$error={$error}
					pattern={pattern}
					maxLength={maxLength}
				/>
			</InputMask>
			{$error && <ErrorDiv>{$error}</ErrorDiv>}
		</Container>
	);
};

interface InputProps {
	name?: string;
	label?: string;
	type?: string;
	inputmode?: string;
	defaultValue?: string;
	size?: string;
	value?: string | number;
	placeholder?: string;
	$error?: string | null;
	onChange?: (e: any) => void;
	pattern?: string;
	maxLength?: number;
}

const Label = styled.label`
	font-size: 18px;
	margin-bottom: 12px;
`;

const StyledInput = styled.input<InputProps>`
	width: 100%;
	padding: 8px;
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.04);
	background: transparent;
	height: 40px;
	border: 1px solid;
	border-radius: 4px;
	border-color: ${props => (props.$error ? '#db2828' : '#d9d9d9')};
	color: #575757;
	font-weight: bold;

	::placeholder {
		color: #575757;
		font-weight: bold;
	}
`;

const ErrorDiv = styled.div`
	margin-top: 8px;
	color: #db2828 !important;
	font-weight: bold;
	font-size: 90%;
	line-height: 125%;
	margin-bottom: 0;
`;
